<template>
  <div>
    <!-- <el-dialog style="border-radius: 8px;" :show-close="false" top="calc((100vh - 800px)/2)" :visible="value" width="840px" :before-close="handleClose">
      <div class="content_box">
        <div class="header">
          <div class="left_header">
            <div class="title">请选择职位类型</div>
            <div class="tip">平台根据职位类型推荐牛人</div>
          </div>
          <div class="right_header">
            <i class="el-icon-close" @click="handleClose"></i>
          </div>
        </div>
        <div class="contet">
          <el-scrollbar style="height: 100%;">
            <el-radio-group v-model="seletRadio" size="small">
              <el-radio v-for="(item,index) in seletctOption" :key="item.value" :label="item.label" border>
                {{ item.label }} <span class="icon_show" v-if="index==0">推荐</span>
              </el-radio>
            </el-radio-group>
          </el-scrollbar>
        </div>
        <div class="footer_box">
          <span @click="goAllDialog">查看全部职位类型</span>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog style="border-radius: 8px;" :show-close="false" top="calc((100vh - 800px)/2)" :visible="value" width="840px" :before-close="handleClose">
      <div class="all_content_box ">
        <div class="header">
          <div class="left_header left-box">
            <div class="title">请选择职类</div>
            <el-input v-model="searchValue" placeholder="请输入职位名称"></el-input>
          </div>
          <div class="right_header">
            <i class="el-icon-close" @click="handleAllClose"></i>
          </div>
        </div>
        <div class="all_zhiye_box">
          <div class="left_box">
            <el-scrollbar style="height: 100%;">
              <div class="menu_item" @click="selectFirst(item.value)" :class="item.value==current_first_value?'active_menu_item':''" v-for="item in zymc" :key="item.value">
                {{ item.label }}
              </div>

            </el-scrollbar>
          </div>
          <div class="right_box">
            <el-scrollbar style="height: 100%;">
              <div class="second_menu">
                <div class="js_row" v-for="(item,index) in secondMenu" :key="index">

                  <div v-for="(itemc,index1) in item" class="second_menu_item" :key="itemc.value" @click="selectSecond(itemc,index)">
                    <span class="button">
                      <i :class="itemc.value!=current_second_value?'el-icon-plus':'el-icon-minus'"></i>
                    </span> {{ itemc.label }}

                  </div>
                  <div class="third_menu" v-if="currentSindex==index">
                    <div v-for="(item,index2) in thirdMenu" class="third_menu_item" :class="currentThirdValue==item.value?'active_third_menu_item':''" :key="item.value" @click="selectItem(item)">
                      {{ item.label }}
                    </div>
                  </div>
                </div>

              </div>
            </el-scrollbar>
          </div>

        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import zymc from "@/utils/zymc.json";
export default {
  name: "",
  props: {
    value: {
      type: Boolean,
      require: true,
    },
    name: {
      type: String,
    },
    desc: {
      type: String,
    },
  },
  data() {
    return {
      searchValue: "",
      seletRadio: null,
      seletctOption: [],
      current_first_value: "",
      current_second_value: "",
      current_third_value: "",
      zymc: zymc,
      tuijianData: [],
      allDialog: false,
      secondMenu: [],
      thirdMenu: [],
      currentSindex: null,
      currentThirdValue: null,
    };
  },
  mounted() {
    // 根据name 来筛选出来类别
    if (this.name && this.desc) {
      this.seletctOption = this.recommendJobs(this.name, this.desc, this.zymc);
    }
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
    },
    recommendJobs(name, desc, config) {
      const matchedJobs = [];
      const keywords = (name + " " + desc)
        .toLowerCase()
        .trim()
        .split(/\s+/)
        .filter((k) => k);

      // 递归遍历配置数据，寻找第三级岗位
      function traverse(node, level = 1) {
        if (!node || !node.children || !node.children.length) return;

        node.children.forEach((child) => {
          if (level === 2) {
            // 第三级岗位（level从1开始，这里level=2的子节点是第三级）
            const jobName = child.label.toLowerCase();
            const jobCode = child.value;
            const jobKeywords = jobName.split(/\s+/).filter((k) => k);

            // 匹配逻辑：名称包含关键词或描述包含岗位名称关键词
            const nameMatched = keywords.some((k) => jobName.includes(k));
            const descMatched = jobKeywords.some((k) =>
              desc.toLowerCase().includes(k)
            );

            if (nameMatched || descMatched) {
              matchedJobs.push({ label: child.label, value: jobCode });
            }
          } else {
            // 继续遍历下一级
            traverse(child, level + 1);
          }
        });
      }

      // 开始遍历整个配置
      config.forEach((root) => traverse(root));

      // 去重（如果有重复岗位）
      return [
        ...new Map(matchedJobs.map((item) => [item.value, item])).values(),
      ];
    },
    goAllDialog() {
      this.handleClose();
    //   this.allDialog = true;
    },
    handleAllClose() {
     this.$emit("closeDialog");
    },
    selectFirst(value) {
      this.current_first_value = value;
      let obj = this.zymc.find((item) => item.value == value);
      this.secondMenu = [];
      //this.secondMenu = obj.children;
      this.secondMenu = this.groupArrayBy4(obj.children);
    },
    selectSecond(item, index) {
      this.current_second_value =
        this.current_second_value != item.value ? item.value : null;
      this.thirdMenu = item.children;
      this.currentSindex = this.current_second_value != null ? index : null;
    },
    groupArrayBy4(arr) {
      const result = [];
      // 遍历原数组，每4个元素组成一个新数组
      for (let i = 0; i < arr.length; i += 4) {
        // 从当前索引开始，截取最多4个元素
        const group = arr.slice(i, i + 4);
        result.push(group);
      }
      return result;
    },
    selectItem(item) {
      this.currentThirdValue = item.value;
      this.$emit("getThirdValue", item);
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang='scss' scoped>
.content_box {
  width: 100%;
  height: 562px;
  background: #fff;
  box-sizing: border-box;
  padding: 30px 30px 24px 30px;
  border-radius: 8px !important;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left_header {
      .title {
        font-size: 20px;
        font-weight: 500;
        color: #444444;
        line-height: 20px;
        margin-bottom: 10px;
      }
      .tip {
        font-size: 14px;
        font-weight: 400;
        color: #757575;
        line-height: 20px;
        margin-bottom: 24px;
      }
    }

    .right_header {
      font-size: 20px;
      cursor: pointer;
    }
  }
  .contet {
    width: 100%;
    height: 450px;
    padding-bottom: 60px;
    box-sizing: border-box;
  }
  .footer_box {
    position: absolute;
    background: #fff;
    bottom: 0;
    left: 0;
    width: 100%;
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    padding: 30px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 400;
    color: #00a6a7;
    line-height: 22px;
    margin-right: 10px;
    span {
      cursor: pointer;
    }
  }
}
.all_content_box {
  .header {
    width: 100%;
    padding: 30px 30px 24px 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .left_header {
      .title {
        font-size: 20px;
        font-weight: 500;
        color: #444444;
        line-height: 20px;
        margin-bottom: 10px;
        flex-shrink: 0;
        align-items: center;
      }
      .tip {
        font-size: 14px;
        font-weight: 400;
        color: #757575;
        line-height: 20px;
        margin-bottom: 24px;
      }
    }
    .left-box {
      display: flex;
      align-items: center;
      .title {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
        margin-right: 10px;
      }
    }
    .right_header {
      font-size: 20px;
      cursor: pointer;
    }
  }
  .all_zhiye_box {
    height: 480px;
    padding-bottom: 30px;
    box-sizing: border-box;
    display: flex;
    .left_box {
      width: 146px;
      height: 100%;
      background: #f9fafb;
      .menu_item {
        white-space: nowrap;
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #424a5e;
        padding-left: 23px;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        box-sizing: border-box;
      }
      .active_menu_item {
        background: #fff;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 4px;
          /* 竖条的宽度 */
          height: 100%;
          /* 竖条的高度，与内容区域高度一致 */
          background-color: #5dd5c8;
          /* 竖条的颜色 */
          border-radius: 2px;
        }
      }
    }
    .right_box {
      flex: 1;
      width: 0;
      .second_menu {
        width: 100%;
        // height: 100%;
        // display: flex;
        padding: 10px 22px 22px;
        box-sizing: border-box;

        .js_row {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .second_menu_item {
            width: 25%;
            height: 40px;
            display: flex;
            align-items: center;
            cursor: pointer;
            .button {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 14px;
              height: 14px;
              margin-right: 5px;
              color: #2cc7b7;
              border: 1px #2cc7b7 solid;
              font-size: 12px;
              cursor: pointer;
            }
          }
          .third_menu {
            width: 100%;
            border: 1px solid #f3f3f3;
            zoom: 1;
            overflow: hidden;
            padding: 8px 0;
            display: flex;
            flex-wrap: wrap;
            .third_menu_item {
              width: 25%;
              cursor: pointer;
              padding: 6px 0 6px 17px;
              line-height: 40px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              position: relative;
              display: flex;
              align-items: center;
            }
            .active_third_menu_item {
              color: #00a6a7;
            }
          }
        }
      }
    }
  }
}
.el-radio-group {
  display: flex;
  flex-direction: column;
  .el-radio {
    width: 100%;
    margin: 0 !important;
    margin-bottom: 10px !important;
    padding: 24px 30px 24px 46px !important;
    box-sizing: border-box;
    height: 114px !important;
    display: flex;
    align-items: center;
    font-weight: 500 !important;
    ::v-deep .el-radio__label {
      font-size: 16px !important;
    }
    &:hover {
      background: #f8f8f8;
    }
  }
}
.icon_show {
  border-radius: 1px;
  border: 1px solid #00c2b3;
  box-sizing: border-box;
  text-align: center;
  line-height: 14px;
  font-size: 12px;
  color: #00c2b3;
  vertical-align: middle;
  margin-left: 4px;
  font-weight: 400;
}
::v-deep .el-radio.is-bordered.is-checked {
  border-color: #dcdfe6 !important;
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #00a6a7 !important;
  background: #00a6a7;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #414a75;
}
::v-deep .el-dialog__body {
  padding: 0px !important;
  border-radius: 8px !important;
}

::v-deep .el-dialog {
  border-radius: 8px !important;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
::v-deep .el-scrollbar__bar .is-horizontal {
  display: none;
}
</style>
